import { render, staticRenderFns } from "./Zec.vue?vue&type=template&id=31a50dc9&"
import script from "./Zec.vue?vue&type=script&lang=js&"
export * from "./Zec.vue?vue&type=script&lang=js&"
import style0 from "./Zec.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports